module.exports = __webpack_public_path__ + "img/p41-desc.d10c38fb.png";